function calcSubmenuPosition() {
  const target = document.querySelector('.align-menu-target')
  const navLink = target.querySelector('.nav-link')
  const subMenu = document.querySelectorAll('.submenu')

  const rect = navLink.getBoundingClientRect()
  const distanceLeftToScreen = rect.left

  subMenu.forEach((el) => {
    el.style.paddingLeft = `${distanceLeftToScreen}px`
  })
}

setTimeout(() => {
  calcSubmenuPosition()
}, 1000)
addEventListener('DOMContentLoaded', calcSubmenuPosition)
addEventListener('resize', calcSubmenuPosition)
